import React from "react";
import { useTranslation } from "react-i18next";
import ChevronLeft from "../icons/heroicons/solid/ChevronLeft";

const BackButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center cursor-pointer" onClick={onClick}>
      {/* ใช้ fill ให้เป็นสีขาวแทน */}
      <ChevronLeft className="w-6 h-full" />
      <div className="text-white text-center text-lg font-medium">
        {t("go_back")}
      </div>
    </div>
  );
};

export default BackButton;
